import { createStore } from 'redux';

let store;

const initStore = ({ reducerManager, composedEnhancers }) => {
  store = createStore(reducerManager.reduce, composedEnhancers);

  store.reducerManager = reducerManager;
};

const getStore = () => store;

export { initStore, getStore };
